import API from "./api";

// ==============================
// CREATE PAYMENT (RAZORPAY ORDER)
// ==============================
export const createPayment = async (orderId, amount) => {
  const res = await API.post("/payments", {
    order_id: orderId,
    amount: Number(amount),
    payment_method: "online",
  });

  return res.data.payment;
};

// ==============================
// PAYMENT SUCCESS (RAZORPAY VERIFY)
// ==============================
export const verifyPayment = async (payload) => {
  const res = await API.post("/payments/success", payload);
  return res.data;
};

// ==============================
// PAYMENT FAILED
// ==============================
export const failPayment = async (payload) => {
  const res = await API.post("/payments/failed", payload);
  return res.data;
};

// ==============================
// ADMIN: GET ALL PAYMENTS
// ==============================
export const getAllPayments = async (token) => {
  const res = await API.get("/payments", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

// ==============================
// ADMIN: FILTER PAYMENTS
// ==============================
export const filterPayments = async (params, token) => {
  const query = new URLSearchParams(params).toString();

  const res = await API.get(`/payments/filter?${query}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

// ==============================
// ADMIN: GET PAYMENT BY ORDER ID
// 🔥 UPDATED (IMPORTANT)
// ==============================
export const getPaymentByOrder = async (orderId, token) => {
  const res = await API.get(`/payments/order/${orderId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // ✅ ALWAYS return single object (not array)
  return res.data?.[0] || null;
};

// ==============================
// ADMIN: PAYMENT STATS
// ==============================
export const getPaymentStats = async (token) => {
  const res = await API.get("/payments/stats", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};